import { all } from "redux-saga/effects";

import authSaga from "./sagas/authSaga";
import resourcesSaga from "./sagas/resourcesSaga";
import adminDashboardSaga from "./sagas/adminDashboardSaga";
import membersSaga from "./sagas/membersSaga";
import claimSaga from "./sagas/claimSaga";
import planSaga from "./sagas/planSaga";
import subscriptionSaga from "./sagas/subscriptionSaga";
import collectionSaga from "./sagas/collectionSaga";

export default function* rootSaga() {
    yield all([
        authSaga(),
        resourcesSaga(),
        adminDashboardSaga(),
        membersSaga(),
        claimSaga(),
        planSaga(),
        subscriptionSaga(),
        collectionSaga(),
    ]);
}
